<ion-card
  class="container ion-padding"
  [ngClass]="{
    info: messageInput().displayType === MESSAGE_TYPE.INFO,
    notice: messageInput().displayType === MESSAGE_TYPE.NOTICE,
    alert: messageInput().displayType === MESSAGE_TYPE.ALERT,
  }"
>
  <ion-row>
    <!-- Icon -->
    <ion-col size="1">
      @switch (messageInput().displayType) {
        @case (MESSAGE_TYPE.INFO) {
          <img class="message-type-icon" [src]="IMAGE.INFO" />
        }
        @case (MESSAGE_TYPE.NOTICE) {
          <img class="message-type-icon" [src]="IMAGE.WARNING" />
        }
        @case (MESSAGE_TYPE.ALERT) {
          <img class="message-type-icon" [src]="IMAGE.BANNER_FAIL" />
        }
      }
    </ion-col>

    <!-- Header and Body Text -->
    <ion-col [size]="canSeeButtons() ? 10 : 11">
      <div class="header-text">{{ messageInput().header }}</div>
      <div class="body-text">{{ messageInput().body }}</div>
    </ion-col>

    @if (canSeeButtons()) {
      <!-- Edit and Delete Buttons -->
      <ion-col size="1" class="ion-no-padding">
        <div class="button-container">
          <ion-button
            class="button ion-justify-content-start"
            fill="clear"
            size="small"
            (click)="clickEdit(messageInput())"
          >
            <ion-icon
              slot="start"
              class="action-edit-icon"
              [src]="IMAGE.EDIT_BLUE"
            ></ion-icon>
            {{ CONSTS.EDIT }}
          </ion-button>
          <ion-button
            class="button ion-justify-content-start"
            fill="clear"
            size="small"
            (click)="clickDelete(messageInput())"
          >
            <ion-icon
              slot="start"
              class="action-edit-icon"
              [src]="IMAGE.DELETE"
            ></ion-icon>
            <div class="delete-text">
              {{ CONSTS.DELETE }}
            </div>
          </ion-button>
        </div>
      </ion-col>
    }
  </ion-row>
</ion-card>
